<template>
  <div class="xvue-curd">
    <el-page-header @back="goBack" :content="title"></el-page-header>
    <div class="xvue-form-card">
      <el-row :gutter="20">
        <el-col :span="6" :offset="4">
          <div class="treeDiv">
            <el-tree
              :data="data"
              node-key="id"
              show-checkbox
              default-expand-all
              :default-checked-keys="auth"
              :props="defaultProps"
              ref="tree"
            >
            </el-tree>
          </div>
        </el-col>
        <el-col :span="8">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-s-tools"
            @click="handleSubmit"
            >设置权限</el-button
          >
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getRoleMenu, updateRole, upDataRditMenu } from "@/api/role/role.js";
import { getMenuList } from "@/api/menu/menu.js";
export default {
  name: "auth.vue",
  created() {
    this.getAuthList();
    //this.getTreeList();
  },
  data() {
    return {
      filterText: "",
      id: this.$route.params.id,
      title: "设置" + this.$route.query.title + "权限集",
      data: [],
      auth: [7, 2, 6],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  methods: {
    getAuthList() {
      getRoleMenu
        .r({
          id: this.id
        })
        .then(res => {
          let auth = [];
          for (let i = 0; i < res.menus.length; i++) {
            auth.push(res.menus[i].id);
          }
          this.auth = auth;
          this.getTreeList();
        });
    },
    getTreeList() {
      getMenuList.r().then(res => {
        this.data = res;
      });
    },
    handleSubmit() {
      let postData = {
        id: this.id,
        menu_set: this.$refs.tree.getCheckedKeys()
      };
      upDataRditMenu.r(postData).then(res => {
        this.$message.success("权限集设置成功~");
        this.goBack();
      });
    },
    goBack() {
      this.$router.go(-1);
      // this.$router.push('/role/list/');
    }
  }
};
</script>

<style scoped>
.treeDiv {
  border-right: 1px #ebeef5 dotted;
  padding-right: 30px;
}
</style>
